import React, { memo, useCallback } from 'react';
import { bool, func } from 'prop-types';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';
import { urls } from 'constants/urls';
import AnchorLink from 'components/AnchorLink';
import SeasonalMenu from '../SeasonalMenu';

import styles from './MenuLinksBar.scss';

const LinksBar = memo(({ onToggleSeasonalMenu, isSeasonalMenuOpen }) => {
  const { trackEvent } = useAnalytics();

  const pushMenuClick = useCallback(
    buttonLabel => {
      trackEvent({
        event: 'click_megamenu',
        mega_menu: {
          button_clicked: buttonLabel,
        },
      });
    },
    [trackEvent],
  );

  return (
    <div className={styles.siteHeaderLinks} data-testid="site-header-links">
      <nav className={styles.primaryLinks} aria-label="Main navigation">
        <SeasonalMenu
          onToggleSeasonalMenu={onToggleSeasonalMenu}
          isSeasonalMenuOpen={isSeasonalMenuOpen}
        />
        <AnchorLink
          to={urls.offers}
          className={styles.offers}
          id="site-header-offers"
          data-testid="site-header-offers"
          onClick={() => pushMenuClick('Offers')}
        >
          Offers
        </AnchorLink>
        <AnchorLink
          to={urls.entertainingHome}
          className={styles.links}
          data-testid="site-header-entertaining"
          id="site-header-entertaining"
          onClick={() => pushMenuClick('Entertaining')}
        >
          Entertaining
        </AnchorLink>
        <AnchorLink
          id="site-header-new"
          data-testid="site-header-new"
          className={styles.links}
          to={urls.new}
          onClick={() => pushMenuClick('New')}
        >
          {/* {isExperiment ? 'Trending' : 'New'} */}
          New
        </AnchorLink>
        <AnchorLink
          id="site-header-recipes"
          data-testid="site-header-recipes"
          className={styles.links}
          to="/ecom/recipes"
          onClick={() => pushMenuClick('Recipes')}
        >
          Recipes
        </AnchorLink>
        <AnchorLink
          id="site-header-inspiration"
          data-testid="site-header-inspiration"
          className={styles.links}
          to={urls.inspiration}
          onClick={() => pushMenuClick('Inspiration')}
        >
          Inspiration
        </AnchorLink>
      </nav>
    </div>
  );
});

LinksBar.displayName = 'LinksBar';

LinksBar.propTypes = {
  isSeasonalMenuOpen: bool,
  onToggleSeasonalMenu: func.isRequired,
};

LinksBar.defaultProps = {
  isSeasonalMenuOpen: false,
};

export default LinksBar;
